import PayNow from './pay-now';

export default PayNow;
